// This file was automatically generated from uiwidget.multifieldListeditor.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.multifieldListeditor');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.multifieldListeditor.entry = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="multifield-entry el8MultifieldEntry" data-index="', soy.$$escapeHtml(opt_data.index), '"></li>');
  if (!opt_sb) return output.toString();
};
